<template>
  <div class="edit-notification">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"><strong>{{ $t("notification") }}</strong></mdb-card-title>
      </mdb-card-header>
      <mdb-card-body v-if="this.loadReady === true">
        <RetailerChainSelection v-on:member="member" :content="notification" />
        <mdb-row>
          <mdb-col md="12">
            <GoogleMap v-on:marker-moved="markerMoved" :marker="computedMarker" class="google-map" />
          </mdb-col>
          <mdb-col md="12" class="mt-3">
            <p class="h5">{{ $t("notification_radius") }}</p>
            <Slider :initialValue="marker.radius / 1000" :sliderData="sliderData" v-on:radius="selectedRadius" />
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-5">
          <mdb-col md="12">
            <p class="h5">{{ $t("notification_content") }}</p>
          </mdb-col>
          <mdb-col>
            <mdb-input v-model="notification.title" v-if="this.loadReady === true" type="text" icon="quote-right"
              :label="$t('notification_title')" />
          </mdb-col>
          <mdb-col>
            <Categories v-on:categories="selectedCategories" v-if="this.loadReady === true" :multipleSelected="false"
              :categoriesInAdv="notification.category_id ? [{ id: notification.category_id }] : []" />
          </mdb-col>
          <mdb-col>
            <NotificationGrouping v-on:groups="selectedGroups" :notificationGroupsId="notification.groups" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <DateTimePicker v-on:datetime-changed="dateTimeChanged"
              v-if="notification.due.length > 0 && !isNotification()" :date-time="notification.due"
              :title="$t('notification_datepicker_title')" />
          </mdb-col>
          <mdb-col md="12">
            <mdb-btn @click="saveNotification" color="indigo" class="white-text" icon="paper-plane">{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";
import RetailerChainSelection from "./RetailerChainSelection.vue";
import GoogleMap from "./GoogleMap.vue";
import Slider from "./Slider.vue";
import Categories from "./Categories.vue";
import DateTimePicker from "./DateTimePicker.vue";
import NotificationGrouping from "./NotificationGrouping.vue";
import moment from "moment";

export default {
  name: "EditNotification",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    RetailerChainSelection,
    GoogleMap,
    Slider,
    Categories,
    DateTimePicker,
    NotificationGrouping,
  },
  props: {
    notificationType: String,
    unionmemberid: {
      type: String,
      default: "",
    },
    defaultMarker: Object,
  },
  methods: {
    defaultDateTime() {
      var m = moment().add(7, "days");
      m.set({ hour: 12, minute: 0, second: 0, millisecond: 0 });
      return m.format("YYYY-MM-DD HH:mm");
    },
    defaultNowDateTime() {
      var m = moment();
      return m.format("YYYY-MM-DD HH:mm");
    },
    setUnionMemberId(val) {
      this.notification.unionmember_id = val;
    },
    loadNotification() {
      if (!this.isNewNotification()) {
        this.getNotification(this.getNotificationId());
      } else {
        this.loadReady = true;
      }
    },
    getNotificationId() {
      try {
        return parseInt(this.$route.path.match(/(\d+)/)[0]);
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    isNotification() {
      return (this.notification.notificationtype != null && this.notification.notificationtype.localeCompare(
        this.$store.state.simplenotification
      ) === 0
      );
    },
    isNewNotification() {
      return this.getNotificationId() === 0;
    },
    member(member) {
      if (member === undefined) return;
      this.notification.retailer = member;
      if (this.notificationFromBackend === false) {
        this.marker.position.lat = Number(member.lat);
        this.marker.position.lng = Number(member.lng);
        this.createMarker();
      }
      this.notificationFromBackend = false;
    },
    dateTimeChanged(val) {
      if (!this.notification.due || this.notification.due.localeCompare(val) !== 0) {
        this.notification.due = val;
      }
    },
    createMarker() {
      var marker = {
        name: "Position",
        position: {
          lat: Number(this.marker.position.lat),
          lng: Number(this.marker.position.lng),
        },
        radius: this.marker.radius,
      };
      this.marker = marker;
    },
    markerMoved(val) {
      this.marker.position.lat = val.getPosition().lat();
      this.marker.position.lng = val.getPosition().lng();
      this.createMarker();
      console.log(val);
    },
    selectedGroups(value, text) {
      this.notification.groups = value.toString();
      console.log(value, text);
    },
    selectedRadius(val) {
      this.marker.radius = val * 1000;
      this.createMarker();
    },
    selectedCategories(value, text) {
      this.notification.category_id = value;
      console.log(value, text);
    },
    getNotification(id) {
      this.$notify.info({
        message: this.$t("loading_notification"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.getnotificationpath + id)
        .then((response) => {
          if (response.status == 200) {
            this.notification = response.data.notifications[0];
            setTimeout(() => this.fillPage(), 2000);
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    fillPage() {
      this.notification.retailer_id = this.notification.retailer.id;
      this.marker.name = this.notification.title;
      this.marker.position.lat = Number(this.notification.lat);
      this.marker.position.lng = Number(this.notification.lng);
      this.notificationFromBackend = true;
      this.marker.radius = this.notification.radius * 1000;
      this.createMarker();
      this.loadReady = true;
    },
    saveNotification() {
      this.postData = {
        id: this.getNotificationId(),
        unionmember_id: this.notification.unionmember_id,
        retailer_id: this.notification.retailer.id,
        groups: this.notification.groups,
        title: this.notification.title,
        lat: this.marker.position.lat,
        lng: this.marker.position.lng,
        category_id: this.notification.category_id,
        radius: this.marker.radius / 1000,
        due: this.isNotification()
          ? this.defaultNowDateTime()
          : this.notification.due,
        notificationtype: this.notification.notificationtype,
      };
      console.log(this.postData);
      this.$http
        .post(this.savenotificationpath, JSON.stringify(this.postData))
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_notification_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          this.$emit("modal-ok");
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("adding_notification_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
  computed: {
    computedMarker() {
      return this.marker;
    },
  },
  mounted() {
    this.loadNotification();
  },
  data() {
    return {
      savenotificationpath: "/1.0/front/notification",
      getnotificationpath: "/1.0/front/notification/",
      notification: {
        category_id: null,
        due: this.defaultDateTime(),
        groups: "",
        id: 0,
        lat: "",
        lng: "",
        radius: 700,
        retailer: {
          id: 0,
          lat: "",
          lng: "",
          name: "",
        },
        retailerchain: {
          description: "",
          id: 0,
          name: "",
        },
        title: "",
        unionmember_id: null,
        notificationtype: this.notificationType,
      },
      notificationFromBackend: false,
      formattedDateTime: "",
      marker: this.defaultMarker,
      loadReady: false,
      sliderData: [
        1, 2, 3, 5, 7, 10, 15, 20, 30, 40, 50, 70, 100, 200, 300, 500, 700,
        1000, 1500,
      ],
    };
  },
};
</script>

<style>
.google-map {
  height: 300px;
  width: auto;
}
</style>
